import { settingDefinition } from '@didto/domain';
import type { SettingKey, SettingValue } from '@didto/domain';
import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/lib/supabase';
import { useSession } from './session';

/** Effective business-level value of a setting (location overrides are a later concern for the UI). */
export function useSetting(key: SettingKey): SettingValue {
  const s = useSession();
  const businessId = s.me?.business?.id ?? '';
  const q = useQuery({
    queryKey: ['business-settings', businessId],
    enabled: !!businessId,
    staleTime: 60_000,
    queryFn: async () => {
      const { data, error } = await supabase
        .from('business_setting')
        .select('key, value')
        .eq('business_id', businessId);
      if (error) throw error;
      return data.map((r) => ({ key: r.key, value: r.value as SettingValue }));
    },
  });
  const row = q.data?.find((r) => r.key === key);
  return row ? row.value : (settingDefinition(key)!.default as SettingValue);
}
